module.exports = __webpack_public_path__ + "media/images/games/k2gender/gymnast-00ffd8255f9c45c9406b9afb129afbbf.png";